import { currentEnv, ROLE_TENANT_OWNER } from "./constants/constants";
import { useShallowEqualSelector } from "../store";

export function hasAccessToNavEntry(
  entryObject,
  currentUserRole,
  currentUserPermissions = []
) {
  const { requireAllPermissions } = entryObject;

  return (
    (!entryObject.role || entryObject.role.includes(currentUserRole)) &&
    (!entryObject.permissions ||
      currentUserRole === ROLE_TENANT_OWNER ||
      entryObject.permissions[requireAllPermissions ? "every" : "some"](
        (permission) => currentUserPermissions.includes(permission)
      )) &&
    (!entryObject.access || entryObject.access.includes(currentEnv))
  );
}

export function useHasAccessToNavEntry(entryObject) {
  const { role, permissions } = useShallowEqualSelector((state) => ({
    role: state.auth.role,
    permissions: state.auth.permissions,
  }));
  return hasAccessToNavEntry(entryObject, role, permissions);
}
